import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
const {Form, FormActions, FormBody} = form;

/**
 * Formulář pro změnu hesla uživatele.
 */
class ZmenaHeslaForm extends Component<WithTranslation> {

    static formName = 'ZmenaHeslaForm';

    static validate = (data, props) => {
        const {t} = props;
        const errors = utils.requireFields(["password", "password_repeat"])(data);
        if (data.password && data.password_repeat && data.password !== data.password_repeat) {
            errors.password_repeat = t('validation.not_matching_passwords');
        }
        return errors;
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String name="oldPassword" label={t('old_password')} type="password" />
                <ff.String name="password" label={t('new_password')} required type="password" />
                <ff.String name="password_repeat" label={t('new_password_again')} required type="password" />
            </FormBody>
            <FormActions onClose={onClose} submitButton={t('change_password')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: ZmenaHeslaForm.formName,
    validate: ZmenaHeslaForm.validate,
})(ZmenaHeslaForm)));
